(function () {
  function attachObserver() {
    const dealBarsEl = document.querySelector('.kaching-bundles__bars:not(.kaching-bundles__subscriptions)');
    if (!dealBarsEl) return false;

    function syncPrice() {
      const selectedBar = dealBarsEl.querySelector('.kaching-bundles__bar--selected');
      if (!selectedBar) return;

      const price = selectedBar.querySelector('.kaching-bundles__bar-price .money')?.textContent.trim();
      const comparePrice = selectedBar.querySelector('.kaching-bundles__bar-full-price .money')?.textContent.trim();

      if (!price) return;

      document.querySelectorAll(
        '[id^="price-template--"] .price-item--sale.price-item--last .money, ' +
        '[id^="sticky-price-template--"] .price-item--sale.price-item--last .money'
      ).forEach(el => { el.textContent = price; });

      if (comparePrice) {
        document.querySelectorAll(
          '[id^="price-template--"] .price-item--lower .money, ' +
          '[id^="sticky-price-template--"] .price-item--lower .money'
        ).forEach(el => { el.textContent = comparePrice; });
      }

      // Reveal price block after first correct sync
      document.querySelectorAll('[id^="price-template--"] .price__container')
        .forEach(el => { el.style.visibility = 'visible'; });
    }

    new MutationObserver(syncPrice).observe(dealBarsEl, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });

    syncPrice();
    return true;
  }

  if (!attachObserver()) {
    const waitObserver = new MutationObserver(function () {
      if (attachObserver()) {
        waitObserver.disconnect();
      }
    });
    waitObserver.observe(document.body, { childList: true, subtree: true });
  }
})();